export default {"src":"/_next/static/media/control_room.0d490fb8.svg","height":1123,"width":794,"blurWidth":0,"blurHeight":0};